var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center temporary-main"},[_c('div',{staticClass:"d-flex flex-column pt-5 col-10"},[_vm._v(" "+_vm._s(_vm.$t(_setup.m.thankYouMessage))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }